import React from 'react';
import { Navigate } from 'react-router';

import { useDelay } from '../hooks/useDelay';

type DelayedRedirectProps = {
    to: string;
    delay?: number;
};

export const DelayedRedirect: React.FC<DelayedRedirectProps> = (props) => {
    const ready = useDelay(props.delay ?? 2000);
    if (ready) {
        return <Navigate to={props.to} replace />;
    }
    return <p>Redirecting, please wait...</p>;
};
